import { AxiosInstance } from 'axios';
import * as moment from 'moment';

import { insertId } from '../../insertId';
import { cancellable } from '../../cancellable';

export interface ITargetCheckSettings {
  isActive: boolean;
  dateFrom: Date | null;
  dateTo: Date | null;
}

const toResponse = (response: any): ITargetCheckSettings => {
  if (!response.success) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${
        response.errorMessage
      }`
    );
  }
  const { isActive, dateFrom, dateTo } = response.result;
  return {
    isActive,
    dateFrom: dateFrom ? moment(dateFrom).toDate() : new Date(),
    dateTo: dateTo ? moment(dateTo).toDate() : new Date(),
  };
};

export default (api: AxiosInstance, url: string) => (id: number) => {
  const urlWithId = insertId(url, id);
  return cancellable<ITargetCheckSettings>(
    (cancelOptions: any) => api.get(urlWithId, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/link/targetCheck/getSettings.ts